var _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNfc(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "800pt",
    height: "800pt",
    viewBox: "0 0 800 800",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0.121094 0.199219 L 50 0.199219 L 50 50 L 0.121094 50 Z M 0.121094 0.199219 "
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 100 0.199219 L 150 0.199219 L 150 50 L 100 50 Z M 100 0.199219 "
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 200 0.199219 L 250 0.199219 L 250 50 L 200 50 Z M 200 0.199219 "
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 300 0.199219 L 350 0.199219 L 350 50 L 300 50 Z M 300 0.199219 "
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 400 0.199219 L 450 0.199219 L 450 50 L 400 50 Z M 400 0.199219 "
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 500 0.199219 L 550 0.199219 L 550 50 L 500 50 Z M 500 0.199219 "
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 600 0.199219 L 650 0.199219 L 650 50 L 600 50 Z M 600 0.199219 "
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 700 0.199219 L 750 0.199219 L 750 50 L 700 50 Z M 700 0.199219 "
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0.121094 100 L 50 100 L 50 150 L 0.121094 150 Z M 0.121094 100 "
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip10"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0.121094 200 L 50 200 L 50 250 L 0.121094 250 Z M 0.121094 200 "
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip11"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0.121094 300 L 50 300 L 50 350 L 0.121094 350 Z M 0.121094 300 "
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip12"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0.121094 400 L 50 400 L 50 450 L 0.121094 450 Z M 0.121094 400 "
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip13"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0.121094 500 L 50 500 L 50 550 L 0.121094 550 Z M 0.121094 500 "
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip14"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0.121094 600 L 50 600 L 50 650 L 0.121094 650 Z M 0.121094 600 "
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip15"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0.121094 700 L 50 700 L 50 750 L 0.121094 750 Z M 0.121094 700 "
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip16"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0.121094 700 L 800 700 L 800 800 L 0.121094 800 Z M 0.121094 700 "
  })))), /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1)",
    clipRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.89856%,92.89856%,93.299866%)",
      fillOpacity: 1
    },
    d: "M 50 0 L 0 0 L 0 50 L 50 50 L 50 0 "
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.89856%,92.89856%,93.299866%)",
      fillOpacity: 1
    },
    d: "M 100 50 L 50 50 L 50 100 L 100 100 L 100 50 "
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2)",
    clipRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.89856%,92.89856%,93.299866%)",
      fillOpacity: 1
    },
    d: "M 150 0 L 100 0 L 100 50 L 150 50 L 150 0 "
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.89856%,92.89856%,93.299866%)",
      fillOpacity: 1
    },
    d: "M 200 50 L 150 50 L 150 100 L 200 100 L 200 50 "
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip3)",
    clipRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.89856%,92.89856%,93.299866%)",
      fillOpacity: 1
    },
    d: "M 250 0 L 200 0 L 200 50 L 250 50 L 250 0 "
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.89856%,92.89856%,93.299866%)",
      fillOpacity: 1
    },
    d: "M 300 50 L 250 50 L 250 100 L 300 100 L 300 50 "
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip4)",
    clipRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.89856%,92.89856%,93.299866%)",
      fillOpacity: 1
    },
    d: "M 350 0 L 300 0 L 300 50 L 350 50 L 350 0 "
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.89856%,92.89856%,93.299866%)",
      fillOpacity: 1
    },
    d: "M 400 50 L 350 50 L 350 100 L 400 100 L 400 50 "
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip5)",
    clipRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.89856%,92.89856%,93.299866%)",
      fillOpacity: 1
    },
    d: "M 450 0 L 400 0 L 400 50 L 450 50 L 450 0 "
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.89856%,92.89856%,93.299866%)",
      fillOpacity: 1
    },
    d: "M 500 50 L 450 50 L 450 100 L 500 100 L 500 50 "
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip6)",
    clipRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.89856%,92.89856%,93.299866%)",
      fillOpacity: 1
    },
    d: "M 550 0 L 500 0 L 500 50 L 550 50 L 550 0 "
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.89856%,92.89856%,93.299866%)",
      fillOpacity: 1
    },
    d: "M 600 50 L 550 50 L 550 100 L 600 100 L 600 50 "
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip7)",
    clipRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.89856%,92.89856%,93.299866%)",
      fillOpacity: 1
    },
    d: "M 650 0 L 600 0 L 600 50 L 650 50 L 650 0 "
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.89856%,92.89856%,93.299866%)",
      fillOpacity: 1
    },
    d: "M 700 50 L 650 50 L 650 100 L 700 100 L 700 50 "
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip8)",
    clipRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.89856%,92.89856%,93.299866%)",
      fillOpacity: 1
    },
    d: "M 750 0 L 700 0 L 700 50 L 750 50 L 750 0 "
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.89856%,92.89856%,93.299866%)",
      fillOpacity: 1
    },
    d: "M 800 50 L 750 50 L 750 100 L 800 100 L 800 50 "
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip9)",
    clipRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.89856%,92.89856%,93.299866%)",
      fillOpacity: 1
    },
    d: "M 50 100 L 0 100 L 0 150 L 50 150 L 50 100 "
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.89856%,92.89856%,93.299866%)",
      fillOpacity: 1
    },
    d: "M 100 150 L 50 150 L 50 200 L 100 200 L 100 150 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.89856%,92.89856%,93.299866%)",
      fillOpacity: 1
    },
    d: "M 150 100 L 100 100 L 100 150 L 150 150 L 150 100 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.89856%,92.89856%,93.299866%)",
      fillOpacity: 1
    },
    d: "M 200 150 L 150 150 L 150 200 L 200 200 L 200 150 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.89856%,92.89856%,93.299866%)",
      fillOpacity: 1
    },
    d: "M 250 100 L 200 100 L 200 150 L 250 150 L 250 100 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.89856%,92.89856%,93.299866%)",
      fillOpacity: 1
    },
    d: "M 300 150 L 250 150 L 250 200 L 300 200 L 300 150 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.89856%,92.89856%,93.299866%)",
      fillOpacity: 1
    },
    d: "M 350 100 L 300 100 L 300 150 L 350 150 L 350 100 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.89856%,92.89856%,93.299866%)",
      fillOpacity: 1
    },
    d: "M 400 150 L 350 150 L 350 200 L 400 200 L 400 150 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.89856%,92.89856%,93.299866%)",
      fillOpacity: 1
    },
    d: "M 450 100 L 400 100 L 400 150 L 450 150 L 450 100 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.89856%,92.89856%,93.299866%)",
      fillOpacity: 1
    },
    d: "M 500 150 L 450 150 L 450 200 L 500 200 L 500 150 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.89856%,92.89856%,93.299866%)",
      fillOpacity: 1
    },
    d: "M 550 100 L 500 100 L 500 150 L 550 150 L 550 100 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.89856%,92.89856%,93.299866%)",
      fillOpacity: 1
    },
    d: "M 600 150 L 550 150 L 550 200 L 600 200 L 600 150 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.89856%,92.89856%,93.299866%)",
      fillOpacity: 1
    },
    d: "M 650 100 L 600 100 L 600 150 L 650 150 L 650 100 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.89856%,92.89856%,93.299866%)",
      fillOpacity: 1
    },
    d: "M 700 150 L 650 150 L 650 200 L 700 200 L 700 150 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.89856%,92.89856%,93.299866%)",
      fillOpacity: 1
    },
    d: "M 750 100 L 700 100 L 700 150 L 750 150 L 750 100 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.89856%,92.89856%,93.299866%)",
      fillOpacity: 1
    },
    d: "M 800 150 L 750 150 L 750 200 L 800 200 L 800 150 "
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip10)",
    clipRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.89856%,92.89856%,93.299866%)",
      fillOpacity: 1
    },
    d: "M 50 200 L 0 200 L 0 250 L 50 250 L 50 200 "
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.89856%,92.89856%,93.299866%)",
      fillOpacity: 1
    },
    d: "M 100 250 L 50 250 L 50 300 L 100 300 L 100 250 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.89856%,92.89856%,93.299866%)",
      fillOpacity: 1
    },
    d: "M 150 200 L 100 200 L 100 250 L 150 250 L 150 200 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.89856%,92.89856%,93.299866%)",
      fillOpacity: 1
    },
    d: "M 200 250 L 150 250 L 150 300 L 200 300 L 200 250 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.89856%,92.89856%,93.299866%)",
      fillOpacity: 1
    },
    d: "M 250 200 L 200 200 L 200 250 L 250 250 L 250 200 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.89856%,92.89856%,93.299866%)",
      fillOpacity: 1
    },
    d: "M 300 250 L 250 250 L 250 300 L 300 300 L 300 250 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.89856%,92.89856%,93.299866%)",
      fillOpacity: 1
    },
    d: "M 350 200 L 300 200 L 300 250 L 350 250 L 350 200 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.89856%,92.89856%,93.299866%)",
      fillOpacity: 1
    },
    d: "M 400 250 L 350 250 L 350 300 L 400 300 L 400 250 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.89856%,92.89856%,93.299866%)",
      fillOpacity: 1
    },
    d: "M 450 200 L 400 200 L 400 250 L 450 250 L 450 200 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.89856%,92.89856%,93.299866%)",
      fillOpacity: 1
    },
    d: "M 500 250 L 450 250 L 450 300 L 500 300 L 500 250 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.89856%,92.89856%,93.299866%)",
      fillOpacity: 1
    },
    d: "M 550 200 L 500 200 L 500 250 L 550 250 L 550 200 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.89856%,92.89856%,93.299866%)",
      fillOpacity: 1
    },
    d: "M 600 250 L 550 250 L 550 300 L 600 300 L 600 250 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.89856%,92.89856%,93.299866%)",
      fillOpacity: 1
    },
    d: "M 650 200 L 600 200 L 600 250 L 650 250 L 650 200 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.89856%,92.89856%,93.299866%)",
      fillOpacity: 1
    },
    d: "M 700 250 L 650 250 L 650 300 L 700 300 L 700 250 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.89856%,92.89856%,93.299866%)",
      fillOpacity: 1
    },
    d: "M 750 200 L 700 200 L 700 250 L 750 250 L 750 200 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.89856%,92.89856%,93.299866%)",
      fillOpacity: 1
    },
    d: "M 800 250 L 750 250 L 750 300 L 800 300 L 800 250 "
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip11)",
    clipRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.89856%,92.89856%,93.299866%)",
      fillOpacity: 1
    },
    d: "M 50 300 L 0 300 L 0 350 L 50 350 L 50 300 "
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.89856%,92.89856%,93.299866%)",
      fillOpacity: 1
    },
    d: "M 100 350 L 50 350 L 50 400 L 100 400 L 100 350 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.89856%,92.89856%,93.299866%)",
      fillOpacity: 1
    },
    d: "M 150 300 L 100 300 L 100 350 L 150 350 L 150 300 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.89856%,92.89856%,93.299866%)",
      fillOpacity: 1
    },
    d: "M 200 350 L 150 350 L 150 400 L 200 400 L 200 350 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.89856%,92.89856%,93.299866%)",
      fillOpacity: 1
    },
    d: "M 250 300 L 200 300 L 200 350 L 250 350 L 250 300 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.89856%,92.89856%,93.299866%)",
      fillOpacity: 1
    },
    d: "M 300 350 L 250 350 L 250 400 L 300 400 L 300 350 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.89856%,92.89856%,93.299866%)",
      fillOpacity: 1
    },
    d: "M 350 300 L 300 300 L 300 350 L 350 350 L 350 300 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.89856%,92.89856%,93.299866%)",
      fillOpacity: 1
    },
    d: "M 400 350 L 350 350 L 350 400 L 400 400 L 400 350 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.89856%,92.89856%,93.299866%)",
      fillOpacity: 1
    },
    d: "M 450 300 L 400 300 L 400 350 L 450 350 L 450 300 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.89856%,92.89856%,93.299866%)",
      fillOpacity: 1
    },
    d: "M 500 350 L 450 350 L 450 400 L 500 400 L 500 350 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.89856%,92.89856%,93.299866%)",
      fillOpacity: 1
    },
    d: "M 550 300 L 500 300 L 500 350 L 550 350 L 550 300 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.89856%,92.89856%,93.299866%)",
      fillOpacity: 1
    },
    d: "M 600 350 L 550 350 L 550 400 L 600 400 L 600 350 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.89856%,92.89856%,93.299866%)",
      fillOpacity: 1
    },
    d: "M 650 300 L 600 300 L 600 350 L 650 350 L 650 300 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.89856%,92.89856%,93.299866%)",
      fillOpacity: 1
    },
    d: "M 700 350 L 650 350 L 650 400 L 700 400 L 700 350 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.89856%,92.89856%,93.299866%)",
      fillOpacity: 1
    },
    d: "M 750 300 L 700 300 L 700 350 L 750 350 L 750 300 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.89856%,92.89856%,93.299866%)",
      fillOpacity: 1
    },
    d: "M 800 350 L 750 350 L 750 400 L 800 400 L 800 350 "
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip12)",
    clipRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.89856%,92.89856%,93.299866%)",
      fillOpacity: 1
    },
    d: "M 50 400 L 0 400 L 0 450 L 50 450 L 50 400 "
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.89856%,92.89856%,93.299866%)",
      fillOpacity: 1
    },
    d: "M 100 450 L 50 450 L 50 500 L 100 500 L 100 450 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.89856%,92.89856%,93.299866%)",
      fillOpacity: 1
    },
    d: "M 150 400 L 100 400 L 100 450 L 150 450 L 150 400 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.89856%,92.89856%,93.299866%)",
      fillOpacity: 1
    },
    d: "M 200 450 L 150 450 L 150 500 L 200 500 L 200 450 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.89856%,92.89856%,93.299866%)",
      fillOpacity: 1
    },
    d: "M 250 400 L 200 400 L 200 450 L 250 450 L 250 400 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.89856%,92.89856%,93.299866%)",
      fillOpacity: 1
    },
    d: "M 300 450 L 250 450 L 250 500 L 300 500 L 300 450 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.89856%,92.89856%,93.299866%)",
      fillOpacity: 1
    },
    d: "M 350 400 L 300 400 L 300 450 L 350 450 L 350 400 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.89856%,92.89856%,93.299866%)",
      fillOpacity: 1
    },
    d: "M 400 450 L 350 450 L 350 500 L 400 500 L 400 450 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.89856%,92.89856%,93.299866%)",
      fillOpacity: 1
    },
    d: "M 450 400 L 400 400 L 400 450 L 450 450 L 450 400 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.89856%,92.89856%,93.299866%)",
      fillOpacity: 1
    },
    d: "M 500 450 L 450 450 L 450 500 L 500 500 L 500 450 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.89856%,92.89856%,93.299866%)",
      fillOpacity: 1
    },
    d: "M 550 400 L 500 400 L 500 450 L 550 450 L 550 400 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.89856%,92.89856%,93.299866%)",
      fillOpacity: 1
    },
    d: "M 600 450 L 550 450 L 550 500 L 600 500 L 600 450 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.89856%,92.89856%,93.299866%)",
      fillOpacity: 1
    },
    d: "M 650 400 L 600 400 L 600 450 L 650 450 L 650 400 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.89856%,92.89856%,93.299866%)",
      fillOpacity: 1
    },
    d: "M 700 450 L 650 450 L 650 500 L 700 500 L 700 450 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.89856%,92.89856%,93.299866%)",
      fillOpacity: 1
    },
    d: "M 750 400 L 700 400 L 700 450 L 750 450 L 750 400 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.89856%,92.89856%,93.299866%)",
      fillOpacity: 1
    },
    d: "M 800 450 L 750 450 L 750 500 L 800 500 L 800 450 "
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip13)",
    clipRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.89856%,92.89856%,93.299866%)",
      fillOpacity: 1
    },
    d: "M 50 500 L 0 500 L 0 550 L 50 550 L 50 500 "
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.89856%,92.89856%,93.299866%)",
      fillOpacity: 1
    },
    d: "M 100 550 L 50 550 L 50 600 L 100 600 L 100 550 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.89856%,92.89856%,93.299866%)",
      fillOpacity: 1
    },
    d: "M 150 500 L 100 500 L 100 550 L 150 550 L 150 500 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.89856%,92.89856%,93.299866%)",
      fillOpacity: 1
    },
    d: "M 200 550 L 150 550 L 150 600 L 200 600 L 200 550 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.89856%,92.89856%,93.299866%)",
      fillOpacity: 1
    },
    d: "M 250 500 L 200 500 L 200 550 L 250 550 L 250 500 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.89856%,92.89856%,93.299866%)",
      fillOpacity: 1
    },
    d: "M 300 550 L 250 550 L 250 600 L 300 600 L 300 550 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.89856%,92.89856%,93.299866%)",
      fillOpacity: 1
    },
    d: "M 350 500 L 300 500 L 300 550 L 350 550 L 350 500 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.89856%,92.89856%,93.299866%)",
      fillOpacity: 1
    },
    d: "M 400 550 L 350 550 L 350 600 L 400 600 L 400 550 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.89856%,92.89856%,93.299866%)",
      fillOpacity: 1
    },
    d: "M 450 500 L 400 500 L 400 550 L 450 550 L 450 500 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.89856%,92.89856%,93.299866%)",
      fillOpacity: 1
    },
    d: "M 500 550 L 450 550 L 450 600 L 500 600 L 500 550 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.89856%,92.89856%,93.299866%)",
      fillOpacity: 1
    },
    d: "M 550 500 L 500 500 L 500 550 L 550 550 L 550 500 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.89856%,92.89856%,93.299866%)",
      fillOpacity: 1
    },
    d: "M 600 550 L 550 550 L 550 600 L 600 600 L 600 550 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.89856%,92.89856%,93.299866%)",
      fillOpacity: 1
    },
    d: "M 650 500 L 600 500 L 600 550 L 650 550 L 650 500 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.89856%,92.89856%,93.299866%)",
      fillOpacity: 1
    },
    d: "M 700 550 L 650 550 L 650 600 L 700 600 L 700 550 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.89856%,92.89856%,93.299866%)",
      fillOpacity: 1
    },
    d: "M 750 500 L 700 500 L 700 550 L 750 550 L 750 500 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.89856%,92.89856%,93.299866%)",
      fillOpacity: 1
    },
    d: "M 800 550 L 750 550 L 750 600 L 800 600 L 800 550 "
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip14)",
    clipRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.89856%,92.89856%,93.299866%)",
      fillOpacity: 1
    },
    d: "M 50 600 L 0 600 L 0 650 L 50 650 L 50 600 "
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.89856%,92.89856%,93.299866%)",
      fillOpacity: 1
    },
    d: "M 100 650 L 50 650 L 50 700 L 100 700 L 100 650 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.89856%,92.89856%,93.299866%)",
      fillOpacity: 1
    },
    d: "M 150 600 L 100 600 L 100 650 L 150 650 L 150 600 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.89856%,92.89856%,93.299866%)",
      fillOpacity: 1
    },
    d: "M 200 650 L 150 650 L 150 700 L 200 700 L 200 650 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.89856%,92.89856%,93.299866%)",
      fillOpacity: 1
    },
    d: "M 250 600 L 200 600 L 200 650 L 250 650 L 250 600 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.89856%,92.89856%,93.299866%)",
      fillOpacity: 1
    },
    d: "M 300 650 L 250 650 L 250 700 L 300 700 L 300 650 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.89856%,92.89856%,93.299866%)",
      fillOpacity: 1
    },
    d: "M 350 600 L 300 600 L 300 650 L 350 650 L 350 600 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.89856%,92.89856%,93.299866%)",
      fillOpacity: 1
    },
    d: "M 400 650 L 350 650 L 350 700 L 400 700 L 400 650 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.89856%,92.89856%,93.299866%)",
      fillOpacity: 1
    },
    d: "M 450 600 L 400 600 L 400 650 L 450 650 L 450 600 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.89856%,92.89856%,93.299866%)",
      fillOpacity: 1
    },
    d: "M 500 650 L 450 650 L 450 700 L 500 700 L 500 650 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.89856%,92.89856%,93.299866%)",
      fillOpacity: 1
    },
    d: "M 550 600 L 500 600 L 500 650 L 550 650 L 550 600 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.89856%,92.89856%,93.299866%)",
      fillOpacity: 1
    },
    d: "M 600 650 L 550 650 L 550 700 L 600 700 L 600 650 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.89856%,92.89856%,93.299866%)",
      fillOpacity: 1
    },
    d: "M 650 600 L 600 600 L 600 650 L 650 650 L 650 600 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.89856%,92.89856%,93.299866%)",
      fillOpacity: 1
    },
    d: "M 700 650 L 650 650 L 650 700 L 700 700 L 700 650 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.89856%,92.89856%,93.299866%)",
      fillOpacity: 1
    },
    d: "M 750 600 L 700 600 L 700 650 L 750 650 L 750 600 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.89856%,92.89856%,93.299866%)",
      fillOpacity: 1
    },
    d: "M 800 650 L 750 650 L 750 700 L 800 700 L 800 650 "
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip15)",
    clipRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.89856%,92.89856%,93.299866%)",
      fillOpacity: 1
    },
    d: "M 50 700 L 0 700 L 0 750 L 50 750 L 50 700 "
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.89856%,92.89856%,93.299866%)",
      fillOpacity: 1
    },
    d: "M 100 750 L 50 750 L 50 800 L 100 800 L 100 750 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.89856%,92.89856%,93.299866%)",
      fillOpacity: 1
    },
    d: "M 150 700 L 100 700 L 100 750 L 150 750 L 150 700 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.89856%,92.89856%,93.299866%)",
      fillOpacity: 1
    },
    d: "M 200 750 L 150 750 L 150 800 L 200 800 L 200 750 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.89856%,92.89856%,93.299866%)",
      fillOpacity: 1
    },
    d: "M 250 700 L 200 700 L 200 750 L 250 750 L 250 700 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.89856%,92.89856%,93.299866%)",
      fillOpacity: 1
    },
    d: "M 300 750 L 250 750 L 250 800 L 300 800 L 300 750 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.89856%,92.89856%,93.299866%)",
      fillOpacity: 1
    },
    d: "M 350 700 L 300 700 L 300 750 L 350 750 L 350 700 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.89856%,92.89856%,93.299866%)",
      fillOpacity: 1
    },
    d: "M 400 750 L 350 750 L 350 800 L 400 800 L 400 750 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.89856%,92.89856%,93.299866%)",
      fillOpacity: 1
    },
    d: "M 450 700 L 400 700 L 400 750 L 450 750 L 450 700 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.89856%,92.89856%,93.299866%)",
      fillOpacity: 1
    },
    d: "M 500 750 L 450 750 L 450 800 L 500 800 L 500 750 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.89856%,92.89856%,93.299866%)",
      fillOpacity: 1
    },
    d: "M 550 700 L 500 700 L 500 750 L 550 750 L 550 700 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.89856%,92.89856%,93.299866%)",
      fillOpacity: 1
    },
    d: "M 600 750 L 550 750 L 550 800 L 600 800 L 600 750 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.89856%,92.89856%,93.299866%)",
      fillOpacity: 1
    },
    d: "M 650 700 L 600 700 L 600 750 L 650 750 L 650 700 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.89856%,92.89856%,93.299866%)",
      fillOpacity: 1
    },
    d: "M 700 750 L 650 750 L 650 800 L 700 800 L 700 750 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.89856%,92.89856%,93.299866%)",
      fillOpacity: 1
    },
    d: "M 750 700 L 700 700 L 700 750 L 750 750 L 750 700 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.89856%,92.89856%,93.299866%)",
      fillOpacity: 1
    },
    d: "M 800 750 L 750 750 L 750 800 L 800 800 L 800 750 "
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip16)",
    clipRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 0 700 L 800 700 L 800 800 L 0 800 L 0 700 "
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(34.498596%,37.998962%,41.19873%)",
      fillOpacity: 1
    },
    d: "M 275.125 763.613281 C 279.976563 763.613281 283.378906 761.039063 283.378906 756.71875 L 283.378906 756.652344 C 283.378906 752.820313 280.835938 751.074219 275.949219 749.886719 C 271.527344 748.828125 270.472656 748.035156 270.472656 746.253906 L 270.472656 746.1875 C 270.472656 744.667969 271.859375 743.449219 274.234375 743.449219 C 276.347656 743.449219 278.425781 744.273438 280.507813 745.824219 L 282.683594 742.757813 C 280.339844 740.875 277.667969 739.851563 274.300781 739.851563 C 269.714844 739.851563 266.414063 742.59375 266.414063 746.550781 L 266.414063 746.617188 C 266.414063 750.875 269.1875 752.328125 274.105469 753.515625 C 278.394531 754.507813 279.316406 755.394531 279.316406 757.046875 L 279.316406 757.113281 C 279.316406 758.863281 277.734375 760.019531 275.226563 760.019531 C 272.355469 760.019531 270.144531 758.929688 267.929688 757.015625 L 265.488281 759.917969 C 268.261719 762.394531 271.59375 763.613281 275.125 763.613281 Z M 240.96875 763.285156 L 244.964844 763.285156 L 244.964844 746.847656 L 257.703125 763.285156 L 261.101563 763.285156 L 261.101563 740.183594 L 257.109375 740.183594 L 257.109375 756.15625 L 244.730469 740.183594 L 240.96875 740.183594 Z M 220.941406 754.109375 L 224.898438 744.867188 L 228.894531 754.109375 Z M 212.921875 763.285156 L 217.078125 763.285156 L 219.453125 757.707031 L 230.378906 757.707031 L 232.722656 763.285156 L 237.015625 763.285156 L 226.847656 740.015625 L 223.085938 740.015625 Z M 195.101563 751.636719 L 195.101563 743.878906 L 201.007813 743.878906 C 204.011719 743.878906 205.796875 745.230469 205.796875 747.707031 L 205.796875 747.773438 C 205.796875 750.117188 203.945313 751.636719 201.042969 751.636719 Z M 191.042969 763.285156 L 195.101563 763.285156 L 195.101563 755.230469 L 200.183594 755.230469 L 205.859375 763.285156 L 210.644531 763.285156 L 204.40625 754.539063 C 207.644531 753.613281 209.921875 751.339844 209.921875 747.542969 L 209.921875 747.476563 C 209.921875 745.464844 209.226563 743.746094 208.007813 742.492188 C 206.519531 741.039063 204.242188 740.183594 201.339844 740.183594 L 191.042969 740.183594 Z M 175.335938 763.285156 L 179.429688 763.285156 L 179.429688 743.945313 L 186.753906 743.945313 L 186.753906 740.183594 L 168.007813 740.183594 L 168.007813 743.945313 L 175.335938 743.945313 Z M 133.6875 763.285156 L 137.683594 763.285156 L 137.683594 746.847656 L 150.421875 763.285156 L 153.820313 763.285156 L 153.820313 740.183594 L 149.828125 740.183594 L 149.828125 756.15625 L 137.449219 740.183594 L 133.6875 740.183594 Z M 116.730469 759.949219 C 112.140625 759.949219 108.871094 756.222656 108.871094 751.734375 L 108.871094 751.667969 C 108.871094 747.179688 112.074219 743.515625 116.660156 743.515625 C 121.25 743.515625 124.519531 747.242188 124.519531 751.734375 L 124.519531 751.796875 C 124.519531 756.289063 121.316406 759.949219 116.730469 759.949219 Z M 116.660156 763.683594 C 123.757813 763.683594 128.773438 758.234375 128.773438 751.734375 L 128.773438 751.667969 C 128.773438 745.164063 123.824219 739.785156 116.730469 739.785156 C 109.632813 739.785156 104.613281 745.230469 104.613281 751.734375 L 104.613281 751.796875 C 104.613281 758.300781 109.566406 763.683594 116.660156 763.683594 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(34.498596%,37.998962%,41.19873%)",
      fillOpacity: 1
    },
    d: "M 292.21875 752.195313 L 292.21875 743.878906 L 296.9375 743.878906 C 299.976563 743.878906 301.921875 745.296875 301.921875 748.003906 L 301.921875 748.070313 C 301.921875 750.480469 300.007813 752.195313 296.9375 752.195313 Z M 288.160156 763.285156 L 292.21875 763.285156 L 292.21875 755.859375 L 296.808594 755.859375 C 301.890625 755.859375 306.050781 753.152344 306.050781 747.972656 L 306.050781 747.902344 C 306.050781 743.253906 302.648438 740.183594 297.269531 740.183594 L 288.160156 740.183594 L 288.160156 763.285156 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(34.498596%,37.998962%,41.19873%)",
      fillOpacity: 1
    },
    d: "M 441.277344 759.6875 L 441.277344 753.351563 L 447.714844 753.351563 C 450.917969 753.351563 452.46875 754.507813 452.46875 756.453125 L 452.46875 756.519531 C 452.46875 758.597656 450.785156 759.6875 448.011719 759.6875 Z M 441.277344 749.917969 L 441.277344 743.777344 L 447.121094 743.777344 C 449.730469 743.777344 451.179688 744.902344 451.179688 746.71875 L 451.179688 746.78125 C 451.179688 748.894531 449.433594 749.917969 446.824219 749.917969 Z M 437.285156 763.285156 L 447.980469 763.285156 C 453.128906 763.285156 456.527344 761.074219 456.527344 756.949219 L 456.527344 756.882813 C 456.527344 753.746094 454.644531 752.195313 451.941406 751.269531 C 453.65625 750.382813 455.238281 748.894531 455.238281 746.121094 L 455.238281 746.058594 C 455.238281 744.507813 454.710938 743.253906 453.6875 742.230469 C 452.367188 740.90625 450.289063 740.183594 447.648438 740.183594 L 437.285156 740.183594 Z M 411.679688 763.285156 L 415.773438 763.285156 L 415.773438 743.945313 L 423.101563 743.945313 L 423.101563 740.183594 L 404.351563 740.183594 L 404.351563 743.945313 L 411.679688 743.945313 Z M 379.933594 763.285156 L 383.925781 763.285156 L 383.925781 746.847656 L 396.664063 763.285156 L 400.066406 763.285156 L 400.066406 740.183594 L 396.070313 740.183594 L 396.070313 756.15625 L 383.695313 740.183594 L 379.933594 740.183594 Z M 357.824219 763.285156 L 375.117188 763.285156 L 375.117188 759.652344 L 361.882813 759.652344 L 361.882813 753.449219 L 373.46875 753.449219 L 373.46875 749.820313 L 361.882813 749.820313 L 361.882813 743.8125 L 374.953125 743.8125 L 374.953125 740.183594 L 357.824219 740.183594 Z M 338.023438 751.636719 L 338.023438 743.878906 L 343.929688 743.878906 C 346.933594 743.878906 348.71875 745.230469 348.71875 747.707031 L 348.71875 747.773438 C 348.71875 750.117188 346.867188 751.636719 343.964844 751.636719 Z M 333.964844 763.285156 L 338.023438 763.285156 L 338.023438 755.230469 L 343.105469 755.230469 L 348.78125 763.285156 L 353.566406 763.285156 L 347.328125 754.539063 C 350.566406 753.613281 352.84375 751.339844 352.84375 747.542969 L 352.84375 747.476563 C 352.84375 745.464844 352.148438 743.746094 350.929688 742.492188 C 349.441406 741.039063 347.164063 740.183594 344.261719 740.183594 L 333.964844 740.183594 Z M 313.933594 754.109375 L 317.894531 744.867188 L 321.890625 754.109375 Z M 305.914063 763.285156 L 310.070313 763.285156 L 312.449219 757.707031 L 323.371094 757.707031 L 325.71875 763.285156 L 330.007813 763.285156 L 319.84375 740.015625 L 316.078125 740.015625 L 305.914063 763.285156 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(34.498596%,37.998962%,41.19873%)",
      fillOpacity: 1
    },
    d: "M 467.148438 754.109375 L 471.109375 744.867188 L 475.105469 754.109375 Z M 459.128906 763.285156 L 463.289063 763.285156 L 465.664063 757.707031 L 476.589844 757.707031 L 478.933594 763.285156 L 483.222656 763.285156 L 473.058594 740.015625 L 469.296875 740.015625 L 459.128906 763.285156 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(34.498596%,37.998962%,41.19873%)",
      fillOpacity: 1
    },
    d: "M 496.488281 763.683594 C 500.8125 763.683594 503.449219 762.097656 505.859375 759.589844 L 503.253906 756.949219 C 501.273438 758.796875 499.457031 759.949219 496.617188 759.949219 C 492.195313 759.949219 488.996094 756.257813 488.996094 751.734375 L 488.996094 751.667969 C 488.996094 747.144531 492.195313 743.515625 496.617188 743.515625 C 499.261719 743.515625 501.238281 744.667969 503.089844 746.386719 L 505.695313 743.382813 C 503.484375 741.269531 500.910156 739.785156 496.652344 739.785156 C 489.65625 739.785156 484.738281 745.164063 484.738281 751.734375 L 484.738281 751.796875 C 484.738281 758.433594 489.753906 763.683594 496.488281 763.683594 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(34.498596%,37.998962%,41.19873%)",
      fillOpacity: 1
    },
    d: "M 510.113281 763.285156 L 514.175781 763.285156 L 514.175781 756.585938 L 517.769531 752.890625 L 525.660156 763.285156 L 530.578125 763.285156 L 520.542969 750.117188 L 530.144531 740.183594 L 525.164063 740.183594 L 514.175781 751.796875 L 514.175781 740.183594 L 510.113281 740.183594 L 510.113281 763.285156 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(34.498596%,37.998962%,41.19873%)",
      fillOpacity: 1
    },
    d: "M 665.179688 759.589844 L 665.179688 743.878906 L 669.734375 743.878906 C 674.585938 743.878906 677.753906 747.210938 677.753906 751.734375 L 677.753906 751.796875 C 677.753906 756.320313 674.585938 759.589844 669.734375 759.589844 Z M 661.121094 763.285156 L 669.734375 763.285156 C 676.996094 763.285156 682.011719 758.234375 682.011719 751.734375 L 682.011719 751.667969 C 682.011719 745.164063 676.996094 740.183594 669.734375 740.183594 L 661.121094 740.183594 Z M 635.050781 763.285156 L 639.042969 763.285156 L 639.042969 746.847656 L 651.785156 763.285156 L 655.183594 763.285156 L 655.183594 740.183594 L 651.1875 740.183594 L 651.1875 756.15625 L 638.8125 740.183594 L 635.050781 740.183594 Z M 619.542969 763.648438 C 625.582031 763.648438 629.476563 760.183594 629.476563 753.285156 L 629.476563 740.183594 L 625.417969 740.183594 L 625.417969 753.480469 C 625.417969 757.738281 623.207031 759.917969 619.609375 759.917969 C 615.980469 759.917969 613.765625 757.609375 613.765625 753.316406 L 613.765625 740.183594 L 609.707031 740.183594 L 609.707031 753.480469 C 609.707031 760.183594 613.535156 763.648438 619.542969 763.648438 Z M 593.109375 759.949219 C 588.519531 759.949219 585.253906 756.222656 585.253906 751.734375 L 585.253906 751.667969 C 585.253906 747.179688 588.457031 743.515625 593.042969 743.515625 C 597.632813 743.515625 600.898438 747.242188 600.898438 751.734375 L 600.898438 751.796875 C 600.898438 756.289063 597.695313 759.949219 593.109375 759.949219 Z M 593.042969 763.683594 C 600.140625 763.683594 605.15625 758.234375 605.15625 751.734375 L 605.15625 751.667969 C 605.15625 745.164063 600.207031 739.785156 593.109375 739.785156 C 586.015625 739.785156 580.996094 745.230469 580.996094 751.734375 L 580.996094 751.796875 C 580.996094 758.300781 585.949219 763.683594 593.042969 763.683594 Z M 562.222656 751.636719 L 562.222656 743.878906 L 568.128906 743.878906 C 571.132813 743.878906 572.914063 745.230469 572.914063 747.707031 L 572.914063 747.773438 C 572.914063 750.117188 571.066406 751.636719 568.160156 751.636719 Z M 558.160156 763.285156 L 562.222656 763.285156 L 562.222656 755.230469 L 567.304688 755.230469 L 572.980469 763.285156 L 577.765625 763.285156 L 571.527344 754.539063 C 574.765625 753.613281 577.039063 751.339844 577.039063 747.542969 L 577.039063 747.476563 C 577.039063 745.464844 576.347656 743.746094 575.125 742.492188 C 573.640625 741.039063 571.363281 740.183594 568.460938 740.183594 L 558.160156 740.183594 Z M 543.246094 763.683594 C 547.339844 763.683594 550.605469 762.03125 552.886719 760.085938 L 552.886719 750.382813 L 543.050781 750.382813 L 543.050781 753.910156 L 548.957031 753.910156 L 548.957031 758.234375 C 547.539063 759.289063 545.558594 759.984375 543.378906 759.984375 C 538.660156 759.984375 535.523438 756.484375 535.523438 751.734375 L 535.523438 751.667969 C 535.523438 747.242188 538.757813 743.515625 543.015625 743.515625 C 545.953125 743.515625 547.703125 744.472656 549.484375 745.988281 L 552.0625 742.921875 C 549.683594 740.90625 547.207031 739.785156 543.183594 739.785156 C 536.21875 739.785156 531.265625 745.265625 531.265625 751.734375 L 531.265625 751.796875 C 531.265625 758.53125 536.019531 763.683594 543.246094 763.683594 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(34.498596%,37.998962%,41.19873%)",
      fillOpacity: 1
    },
    d: "M 231.265625 213.078125 L 231.265625 537.179688 C 231.265625 549.78125 241.480469 560 254.085938 560 L 438.261719 560 C 450.863281 560 461.082031 549.78125 461.082031 537.179688 L 461.082031 213.078125 C 461.082031 200.472656 450.863281 190.257813 438.261719 190.257813 L 254.085938 190.257813 C 241.480469 190.257813 231.265625 200.472656 231.265625 213.078125 Z M 447.78125 226.132813 L 447.78125 524.824219 L 368.441406 524.824219 L 368.441406 537.285156 C 368.441406 541.011719 365.425781 544.027344 361.703125 544.027344 L 330.644531 544.027344 C 326.921875 544.027344 323.902344 541.011719 323.902344 537.285156 L 323.902344 524.824219 L 244.566406 524.824219 L 244.566406 226.132813 Z M 321.582031 202.75 L 370.765625 202.75 C 373.644531 202.75 375.976563 205.082031 375.976563 207.960938 C 375.976563 210.835938 373.644531 213.167969 370.765625 213.167969 L 321.582031 213.167969 C 318.707031 213.167969 316.375 210.835938 316.375 207.960938 C 316.375 205.082031 318.707031 202.75 321.582031 202.75 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(34.498596%,37.998962%,41.19873%)",
      fillOpacity: 1
    },
    d: "M 568.734375 196.824219 C 568.734375 132.304688 516.429688 80 451.910156 80 C 395.234375 80 347.980469 120.363281 337.332031 173.910156 L 354.070313 173.910156 C 364.464844 129.507813 404.386719 96.347656 451.910156 96.347656 C 507.3125 96.347656 552.390625 141.425781 552.390625 196.824219 C 552.390625 243.421875 520.511719 282.710938 477.425781 294.027344 L 477.425781 310.863281 C 529.671875 299.226563 568.734375 252.585938 568.734375 196.824219 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(34.498596%,37.998962%,41.19873%)",
      fillOpacity: 1
    },
    d: "M 519.699219 196.824219 C 519.699219 225.183594 502.195313 249.535156 477.425781 259.628906 L 477.425781 277.003906 C 511.390625 266.183594 536.042969 234.328125 536.042969 196.824219 C 536.042969 150.429688 498.304688 112.691406 451.910156 112.691406 C 413.460938 112.691406 380.949219 138.613281 370.945313 173.910156 L 388.109375 173.910156 C 397.523438 147.773438 422.570313 129.035156 451.910156 129.035156 C 489.289063 129.035156 519.699219 159.445313 519.699219 196.824219 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(34.498596%,37.998962%,41.19873%)",
      fillOpacity: 1
    },
    d: "M 451.910156 161.722656 C 471.261719 161.722656 487.011719 177.472656 487.011719 196.824219 C 487.011719 206.148438 483.355469 214.621094 477.425781 220.90625 L 477.425781 241.496094 C 492.902344 232.609375 503.355469 215.914063 503.355469 196.824219 C 503.355469 168.460938 480.277344 145.378906 451.910156 145.378906 C 431.773438 145.378906 414.300781 157.007813 405.867188 173.910156 L 425.34375 173.910156 C 431.78125 166.449219 441.300781 161.722656 451.910156 161.722656 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(34.498596%,37.998962%,41.19873%)",
      fillOpacity: 1
    },
    d: "M 379.242188 364.855469 C 380.617188 363.382813 381.300781 361.515625 381.300781 359.648438 C 381.300781 357.613281 380.488281 355.585938 378.886719 354.085938 C 360.171875 336.566406 330.851563 336.566406 312.140625 354.085938 C 309.066406 356.960938 308.90625 361.78125 311.78125 364.855469 C 314.65625 367.925781 319.480469 368.085938 322.550781 365.210938 C 335.425781 353.15625 355.597656 353.15625 368.476563 365.210938 C 371.546875 368.085938 376.367188 367.925781 379.242188 364.855469 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(34.498596%,37.998962%,41.19873%)",
      fillOpacity: 1
    },
    d: "M 401.417969 340.859375 C 402.792969 339.390625 403.476563 337.523438 403.476563 335.65625 C 403.476563 333.621094 402.664063 331.59375 401.0625 330.09375 C 369.914063 300.933594 321.113281 300.933594 289.964844 330.09375 C 286.890625 332.96875 286.730469 337.789063 289.609375 340.859375 C 292.484375 343.933594 297.304688 344.09375 300.375 341.214844 C 325.6875 317.519531 365.339844 317.519531 390.648438 341.214844 C 393.722656 344.09375 398.539063 343.933594 401.417969 340.859375 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(34.498596%,37.998962%,41.19873%)",
      fillOpacity: 1
    },
    d: "M 269.8125 321.328125 C 312.261719 281.589844 378.765625 281.589844 421.214844 321.328125 C 424.285156 324.203125 429.105469 324.046875 431.984375 320.972656 C 433.359375 319.503906 434.039063 317.636719 434.039063 315.769531 C 434.039063 313.734375 433.230469 311.703125 431.628906 310.207031 C 408.195313 288.269531 377.609375 276.1875 345.511719 276.1875 C 313.414063 276.1875 282.832031 288.269531 259.398438 310.207031 C 256.324219 313.082031 256.167969 317.902344 259.042969 320.976563 C 261.917969 324.046875 266.738281 324.203125 269.8125 321.328125 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(34.498596%,37.998962%,41.19873%)",
      fillOpacity: 1
    },
    d: "M 326.730469 391.363281 C 326.730469 401.738281 335.140625 410.148438 345.511719 410.148438 C 355.886719 410.148438 364.296875 401.738281 364.296875 391.363281 C 364.296875 380.992188 355.886719 372.582031 345.511719 372.582031 C 335.140625 372.582031 326.730469 380.992188 326.730469 391.363281 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(34.498596%,37.998962%,41.19873%)",
      fillOpacity: 1
    },
    d: "M 424.347656 428.46875 L 265.582031 428.46875 C 262.992188 428.46875 260.894531 430.566406 260.894531 433.15625 L 260.894531 454.5 C 260.894531 457.089844 262.992188 459.1875 265.582031 459.1875 L 424.347656 459.1875 C 426.9375 459.1875 429.035156 457.089844 429.035156 454.5 L 429.035156 433.15625 C 429.035156 430.566406 426.9375 428.46875 424.347656 428.46875 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(34.498596%,37.998962%,41.19873%)",
      fillOpacity: 1
    },
    d: "M 334.257813 474.710938 L 261.578125 474.710938 C 261.199219 474.710938 260.894531 475.015625 260.894531 475.394531 L 260.894531 485.988281 C 260.894531 486.367188 261.199219 486.671875 261.578125 486.671875 L 334.257813 486.671875 C 334.636719 486.671875 334.941406 486.367188 334.941406 485.988281 L 334.941406 475.394531 C 334.941406 475.015625 334.636719 474.710938 334.257813 474.710938 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(34.498596%,37.998962%,41.19873%)",
      fillOpacity: 1
    },
    d: "M 428.351563 474.710938 L 355.671875 474.710938 C 355.292969 474.710938 354.988281 475.015625 354.988281 475.394531 L 354.988281 485.988281 C 354.988281 486.367188 355.292969 486.671875 355.671875 486.671875 L 428.351563 486.671875 C 428.730469 486.671875 429.035156 486.367188 429.035156 485.988281 L 429.035156 475.394531 C 429.035156 475.015625 428.730469 474.710938 428.351563 474.710938 "
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNfc);
export default __webpack_public_path__ + "static/media/NFC.f9b4fad5a5b6c23c354d77edee445498.svg";
export { ForwardRef as ReactComponent };